import { render } from "./JobsList.vue?vue&type=template&id=97d48772&scoped=true&ts=true"
import script from "./JobsList.vue?vue&type=script&lang=ts"
export * from "./JobsList.vue?vue&type=script&lang=ts"

import "./JobsList.vue?vue&type=style&index=0&id=97d48772&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d48772"]])

export default __exports__